import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import { useTheme } from '@sport1/react-elements'
import ThemeInterface from '../../../themes/ThemeInterface'
import { spacings } from '../../../DesignSystem/spacings'
import { radius } from '../../../DesignSystem/border/radius'
import { TestID } from '../../../utils/PropTypesDefinitions'
import Font from '@/Fonts/Font'

export type DummySearchBarProps = {
    placeholder: string
    onPress?: () => void
    size?: 'S' | 'M'
} & TestID

const DummySearchBar: FunctionComponent<DummySearchBarProps> = ({
    placeholder,
    onPress,
    testID,
    size = 'S',
}): ReactElement => {
    const { surfaceColors, fontColors, iconColors } = useTheme() as ThemeInterface
    return (
        <Touchable onPress={onPress} activeOpacity={1}>
            <Grid noExpand horizontal testID={testID} backgroundColor="TRANSPARENT">
                <Grid
                    horizontal
                    backgroundColor={surfaceColors['background-tertiary']}
                    paddingX={spacings['spacing-6']}
                    centerVertical
                    borderRadius={radius['radius-rounded']}
                    height={size === 'M' ? 48 : 36}
                    minWidth={0}
                >
                    <Grid noExpand marginRight={spacings['spacing-3']}>
                        <FontelloIcon
                            name="search"
                            color={iconColors['icon-primary']}
                            fontSize={24}
                        />
                    </Grid>
                    <Grid minWidth={0}>
                        <Grid noExpand>
                            <Font
                                fontVariant="Body-M"
                                fontFamilyVariant="Sport1-Regular"
                                color={fontColors['font-secondary']}
                                numberOfLines={1}
                            >
                                {placeholder}
                            </Font>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default DummySearchBar
